module.exports = __webpack_public_path__ + "static/badgesMap.ca760a76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/badgesMap.svg
// module id = 399
// module chunks = 35783957827783